import { httpClient } from '@/modules/common/services/http/http-client';
import { IPreviewRedemptionProducts } from './types';

export const http = httpClient.withOptions({
  baseURL: `${process.env.VUE_APP_BFF_URL}/portfolios`
});

export function getPreviewRedemptionProducts(
  portfolioId: string
): Promise<IPreviewRedemptionProducts[]> {
  return http.get(`/v1/allocations/preview-redemption/${portfolioId}`);
}
